import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="calendar-populate"
export default class extends Controller {
  static values = {
    startDate: String,
    endDate: String,
    anchorDate: String,
  };

  static targets = ["indicators"];

  connect() {
    const frame = document.getElementById("events");
    frame.src = `/calendar_events?date=${this.anchorDateValue}`;
    this.fetchEventIndicators();
  }

  async fetchEventIndicators() {
    try {
      const response = await fetch(
        `/events/check?start_date=${this.startDateValue}&end_date=${this.endDateValue}`,
      );
      const json = await response.json();

      json.forEach((element) => {
        const timeElement = this.element.querySelector(
          `time[datetime="${element.date}"]`,
        );
        const indicatorsContainer = timeElement.parentElement.querySelector(
          '[data-calendar-populate-target="indicators"]',
        );

        // Add single-day event dot
        if (element.single_day_events) {
          const dot = document.createElement("div");
          dot.classList.add(
            "z-0",
            "w-2",
            "h-2",
            "rounded-full",
            "bg-dinck-orange",
            "top-0",
            "ml-1",
            "left-0",
          );
          timeElement.appendChild(dot);
        }

        // Add spanning event bar
        if (element.spanning_events) {
          const bar = document.createElement("div");
          bar.classList.add(
            "z-0",
            "h-1",
            "w-full",
            "rounded-sm",
            "bg-dinck-purple",
          );
          indicatorsContainer.appendChild(bar);
        }

        // Add national holiday dot
        if (element.holiday) {
          const dot = document.createElement("div");
          dot.classList.add(
            "z-0",
            "w-2",
            "h-2",
            "rounded-full",
            "bg-amber-400",
            "top-0",
            "ml-1",
            "left-0",
          );
          timeElement.appendChild(dot);
        }
      });
    } catch (error) {
      console.error("Error fetching event indicators:", error);
    }
  }
}
